import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { formatAcceptedHandleTypes } from '@/types/node-types';

type PortSummary = {
  display_name: string;
  info?: string;
  accepted_types: readonly string[];
};

// the shared tooltip for input and output ports in workflows builder
interface PortTooltipProps {
  children: React.ReactNode;
  side?: 'right' | 'left';
  port: PortSummary;
}

export const PortTooltip: React.FC<PortTooltipProps> = ({
  children,
  side = 'right',
  port,
}) => {
  const typeLabels = formatAcceptedHandleTypes(
    (port?.accepted_types || []) as string[],
  );

  return (
    <Tooltip delayDuration={1000}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side={side}
        sideOffset={8}
        avoidCollisions={false}
        collisionPadding={0}
        className='p-0'
      >
        <div className='text-xs max-w-sm text-wrap select-none pointer-events-none p-3'>
          <div className='font-semibold mb-1'>{port.display_name}</div>
          {port.info && (
            <div className='opacity-80 leading-snug mb-2'>
              {/* remove period at the end of the description */}
              {String(port.info ?? '').replace(/\.(\s*)$/, '$1')}
            </div>
          )}
          <div className='mt-2 flex items-center gap-2 flex-wrap'>
            <span className='opacity-80 shrink-0'>Types:</span>
            <div className='flex flex-wrap gap-1'>
              {typeLabels.length > 0 ? (
                typeLabels.map((label) => (
                  <span
                    key={label}
                    className='inline-block bg-white dark:bg-gray-300 text-zinc-900 rounded px-1.5 py-0.5 text-[11px]'
                  >
                    {label}
                  </span>
                ))
              ) : (
                <span className='opacity-70'>—</span>
              )}
            </div>
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

export default PortTooltip;
